import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { ApplicationModule, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

if (environment.production) {
    enableProdMode();
}

Sentry.init({
    dsn: 'https://ea214dc0d9824cf3b1d36e045b28d81e@o438224.ingest.sentry.io/4505980133900288',

    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [
        'localhost',
        'sunology-stream-recette.emotic.fr',
        'sunology-stream-preprod.emotic.fr',
        'stream.sunology.eu',
    ],
    enabled: environment.production,
    environment: environment.env,
    // Performance Monitoring
    tracesSampleRate: 0.2, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
